import http from '@/fetch/http'
import Vue from 'vue'
import * as types  from '@/vuex/types'

const state = {
  //总题数
  AllIndex: 0,
  //当前题
  Index: 0,
  //所有试题
  exercisesList: [],
  //是否提交
  isSubmit: false,
  //提交按钮是否可用
  UploadButton: false,
  //是否显示loading
  showLoading: false,
  params: {
    givingHistoryId: '',
    teachingPlanId: '',
    teachingPlanProcessId: '',
  }
}

const actions = {
  /**
   * 随堂测试查找试题列表
   * @param commit
   * @param examId
   */
  selectPractice({commit}, param){
    commit('SET_PARAMS', param);
    http.selectPractice(param)
      .then(res => {
        if (res.msgCode == types.STATUS_OK) {
          //关闭loading
          commit('SET_SHOW_LOADING', false);
          //试题列表赋值
          commit('SET_EXERCISES_LIST', res.data);
          //设置总题数
          commit('SET_ALLINDEX', res.data.length);
          //设置初始化题数
          if (res.data.length > 0) {
            commit('SET_INDEX', 1);
          }
        }
      })
  },
  setPracticeShowLoading({commit}, param){
    commit('SET_SHOW_LOADING', param);
  },
  setPracticeIndex({commit}, index){
    commit('SET_INDEX', index);
  },
  setPracticeUploadButton({commit}, flag){
    commit('SET_UPLOAD_BUTTON', flag);
  },
  setPracticeIsSubmit({commit}, flag){
    commit('SET_IS_SUBMIT', flag);
  },
}

const getters = {}

const mutations = {
  ['SET_IS_SUBMIT'](state, status) {
    Vue.set(state, 'isSubmit', status);
  },
  ['SET_SHOW_LOADING'](state, status) {
    Vue.set(state, 'showLoading', status);
  },
  ['SET_EXERCISES_LIST'](state, list) {
    Vue.set(state, 'exercisesList', list);
  },
  ['SET_INDEX'](state, index) {
    Vue.set(state, 'Index', index);
  },
  ['SET_ALLINDEX'](state, AllIndex) {
    Vue.set(state, 'AllIndex', AllIndex);
  },
  ['SET_UPLOAD_BUTTON'](state, flag) {
    Vue.set(state, 'UploadButton', flag);
  },
  ['SET_PARAMS'](state, param) {
    Vue.set(state, 'params', param);
  },
}

export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/student/practice.js